import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { useGlobalsService } from '../services/useGlobals';
export default function useVariables(variableNames) {
  var globalsService = useGlobalsService();
  var names = useMemo(function () {
    if (!variableNames) return [];
    return Array.isArray(variableNames) ? variableNames : [variableNames];
  }, [variableNames]);
  var queries = useMemo(function () {
    return names.map(function (name) {
      return {
        queryKey: ['variableOptions', name],
        queryFn: function queryFn() {
          return globalsService.fetchVariableOptions(name);
        },
        staleTime: Infinity,
        gcTime: Infinity,
        retry: 3,
        retryDelay: function retryDelay(attemptIndex) {
          return (attemptIndex + 1) * 1000;
        }
      };
    });
  }, [names, globalsService]);
  var results = useQueries({
    queries: queries
  });
  var loading = useMemo(function () {
    return results.some(function (result) {
      return result.isLoading;
    });
  }, [results]);
  var variableOptions = useMemo(function () {
    var options = {};
    results.forEach(function (result, index) {
      if (result.data) {
        options[names[index]] = result.data.data;
      }
    });
    return options;
  }, [results, names]);
  return {
    loading: loading,
    variableOptions: variableOptions
  };
}